import React from "react";
import { toast } from "react-toastify";

import SuccessToast from "../components/Toasts.js/SuccessToast";
import FailToast from "../components/Toasts.js/FailToast";
import WarningToast from "../components/Toasts.js/WarningToast";

const getCloseButtonElement = () => {
    return (
        <>
            <div className="alert-items-close">
                <i className="far fa-times-circle"></i>
            </div>
        </>
    );
};

const formatMessage = (message, fallback) => {
    return typeof message !== "string" ? fallback : message;
};

const ErrorAlert = (message) => {
    toast(
        <FailToast message={formatMessage(message, "Something went wrong")} />,
        {
            hideProgressBar: true,
            position: "top-right",
            className: "alert-message-wrapper alert-message-error show",
            closeButton: getCloseButtonElement(),
        }
    );
    toast.clearWaitingQueue();
};

const WarningAlert = (message) => {
    toast(
        <WarningToast
            message={formatMessage(
                message,
                "Warning this action may contain missing information"
            )}
        />,
        {
            hideProgressBar: true,
            position: "top-right",
            className: "alert-message-wrapper alert-message-warning show",
            closeButton: getCloseButtonElement(),
        }
    );
    toast.clearWaitingQueue();
};

const SuccessAlert = (message) => {
    toast(
        <SuccessToast
            message={formatMessage(
                message,
                "Your action is performed successfully"
            )}
        />,
        {
            hideProgressBar: true,
            position: "top-right",
            className: "alert-message-wrapper alert-message-success show",
            closeButton: getCloseButtonElement(),
        }
    );
};

export { ErrorAlert, SuccessAlert, WarningAlert };
